var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "applyForm" },
    [
      _c(
        "div",
        { staticClass: "applyFormContent" },
        [
          _vm.type == "view"
            ? _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "申请信息", name: "1" },
                  }),
                  _vm.forceLogTab ||
                  _vm.$hasBtnRoles("/user/project-delivery/log")
                    ? _c("el-tab-pane", { attrs: { label: "日志", name: "2" } })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "keep-alive",
            [
              _vm.activeTab == "1"
                ? _c("apply-info-panel", {
                    ref: "infoPanel",
                    attrs: {
                      "form-data": _vm.formData,
                      rules: _vm.rules,
                      type: _vm.type,
                      id: _vm.id,
                      "project-status": _vm.projectStatus,
                      "edit-saving": _vm.editSaving,
                      "company-list": _vm.companyList,
                      "opportunity-list": _vm.opportunityList,
                      "leader-options": _vm.leaderOptions,
                      "decoration-person-list": _vm.decorationPersonList,
                      "card-design-person-list": _vm.cardDesignPersonList,
                      "bid-support-person-list": _vm.bidSupportPersonList,
                      "card-type-list": _vm.cardTypeList,
                      "quotation-card-type-list": _vm.quotationCardTypeList,
                      "business-type-list": _vm.businessTypeList,
                      "quotation-business-type-list":
                        _vm.quotationBusinessTypeList,
                      "initial-types": _vm.initialTypes,
                      "input-name": _vm.inputName,
                      "is-approve-other-demand": _vm.isApproveOtherDemand,
                      "quotation-checkbox-disabled":
                        _vm.quotationCheckboxDisabled,
                      "quotation-checkbox-label": _vm.quotationCheckboxLabel,
                      "show-card-type-field": _vm.showCardTypeField,
                      "had-initial-design-draft": _vm.hadInitialDesignDraft,
                      "get-company-list": _vm.getCompanyList,
                      "change-customer": _vm.changeCustomer,
                      "change-opportunity": _vm.changeOpportunity,
                      "change-project": _vm.changeProject,
                      "should-show-task-type": _vm.shouldShowTaskType,
                      "is-task-form-disabled": _vm.isTaskFormDisabled,
                      "is-editing-task": _vm.isEditingTask,
                      "is-view-task-disabled": _vm.isViewTaskDisabled,
                      "show-project-info-edit-button":
                        _vm.showProjectInfoEditButton,
                      "start-project-info-edit": _vm.startProjectInfoEdit,
                      "confirm-project-info-edit": _vm.confirmProjectInfoEdit,
                      "cancel-project-info-edit": _vm.cancelProjectInfoEdit,
                      "change-order-business-type": _vm.changeOrderBusinessType,
                      "change-quotation-business-type":
                        _vm.changeQuotationBusinessType,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.activeTab == "2"
            ? _c("apply-log-panel", { attrs: { id: _vm.id } })
            : _vm._e(),
        ],
        1
      ),
      _vm.type == "add"
        ? _c(
            "div",
            { staticClass: "form-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("提 交")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.submitLoading },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.type == "approve"
        ? _c(
            "div",
            { staticClass: "form-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.approveLoading },
                  on: { click: _vm.handleApprove },
                },
                [_vm._v("通 过")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.approveLoading },
                  on: { click: _vm.handleReject },
                },
                [_vm._v("驳 回")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.type == "projectReview" &&
      _vm.$hasBtnRoles("/user/project-delivery/project-info") &&
      _vm.$hasBtnRoles("/user/project-delivery/sensitive")
        ? _c(
            "div",
            { staticClass: "form-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitProjectReview },
                },
                [_vm._v("提 交")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批通过",
            visible: _vm.approveDialogVisible,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approveForm",
              attrs: {
                model: _vm.approveFormData,
                rules: _vm.approveRules,
                "label-width": "auto",
              },
            },
            [
              !_vm.formData.chat_id
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否拉群：", prop: "group" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.approveFormData.group,
                            callback: function ($$v) {
                              _vm.$set(_vm.approveFormData, "group", $$v)
                            },
                            expression: "approveFormData.group",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("拉群"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不拉群"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.approveFormData.group == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "群名称：", prop: "groupName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入群名称",
                          maxlength: 50,
                          clearable: "",
                        },
                        model: {
                          value: _vm.approveFormData.groupName,
                          callback: function ($$v) {
                            _vm.$set(_vm.approveFormData, "groupName", $$v)
                          },
                          expression: "approveFormData.groupName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isTaskApproval
                ? _c(
                    "el-form-item",
                    { attrs: { label: "项目负责人：", prop: "handleUser" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "value-key": "id",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.approveFormData.handleUser,
                            callback: function ($$v) {
                              _vm.$set(_vm.approveFormData, "handleUser", $$v)
                            },
                            expression: "approveFormData.handleUser",
                          },
                        },
                        _vm._l(_vm.leaderOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.approveFormData.group == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "其他参与人：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "value-key": "id",
                            multiple: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.otherUsers,
                            callback: function ($$v) {
                              _vm.otherUsers = $$v
                            },
                            expression: "otherUsers",
                          },
                        },
                        _vm._l(_vm.userList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name,
                              value: item,
                              disabled:
                                (_vm.approveFormData.handleUser &&
                                  item.id ===
                                    _vm.approveFormData.handleUser.id) ||
                                _vm.groupUserIds.includes(item.id),
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.approveFormData.group == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "拟拉群名单：" } },
                    [
                      _vm._l(_vm.groupUsers, function (item) {
                        return _c(
                          "el-tag",
                          {
                            key: item.id,
                            staticStyle: { margin: "0 8px 8px 0" },
                            attrs: {
                              closable:
                                item.disable !== 1 &&
                                !(
                                  _vm.approveFormData.handleUser &&
                                  item.id === _vm.approveFormData.handleUser.id
                                ),
                            },
                            on: {
                              close: function ($event) {
                                return _vm.handleGroupUserClose(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      }),
                      _vm.approveFormData.handleUser &&
                      !_vm.groupUserIds.includes(
                        _vm.approveFormData.handleUser.id
                      )
                        ? _c(
                            "el-tag",
                            { staticStyle: { margin: "0 8px 8px 0" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.approveFormData.handleUser.name) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._l(_vm.otherUsers, function (item) {
                        return _c(
                          "el-tag",
                          {
                            key: item.id,
                            staticStyle: { margin: "0 8px 8px 0" },
                            attrs: { closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.handleOtherUserClose(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "审批说明：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入...",
                      rows: 4,
                      maxlength: 500,
                    },
                    model: {
                      value: _vm.approveFormData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.approveFormData, "reason", $$v)
                      },
                      expression: "approveFormData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approveDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.approveLoading },
                  on: { click: _vm.confirmApprove },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批驳回",
            visible: _vm.rejectDialogVisible,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rejectDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "rejectForm",
              attrs: {
                model: _vm.rejectFormData,
                rules: _vm.rejectRules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "驳回原因：", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入驳回原因",
                      rows: 4,
                      maxlength: 500,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.rejectFormData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.rejectFormData, "reason", $$v)
                      },
                      expression: "rejectFormData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rejectDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.approveLoading },
                  on: { click: _vm.confirmReject },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }